const DEFAULT_PLAN = 'pro-yearly'

/**
 * Calculate the required plan based on the current plan
 * Plan hierarchy: essential < plus < pro
 * @param {string} requiredPlanLevel - The required plan level (e.g., 'pro', 'essential', 'plus')
 * @param {string} currentPlan - The current plan type (e.g., 'free', 'pro-monthly', 'edu-small')
 * @returns {string} The required plan in format '{requiredPlanLevel}-{planCycle}'
 */
export function getRequiredPlan(requiredPlanLevel, currentPlan) {
  // Handle falsy values
  if (!requiredPlanLevel || !currentPlan) {
    return DEFAULT_PLAN
  }

  // If currentPlan is pro-yearly (including legacy), no upgrade needed - Pro is highest
  if (currentPlan.includes('pro') && currentPlan.includes('yearly')) {
    return currentPlan
  }

  // If currentPlan is free, return {requiredPlanLevel}-yearly
  if (currentPlan === 'free') {
    return `${requiredPlanLevel}-yearly`
  }

  // If currentPlan is edu plan, return pro-yearly
  if (currentPlan.includes('edu')) {
    return DEFAULT_PLAN
  }

  // If requiredPlanLevel is essential but currentPlan is plus, no downgrade needed
  // Exclude trial plans from this check
  if (requiredPlanLevel === 'essential' && currentPlan.includes('plus') && !currentPlan.includes('trial')) {
    return currentPlan
  }

  // If currentPlan is one-time plan, return {requiredPlanLevel}-yearly
  if (currentPlan.includes('one-time')) {
    return `${requiredPlanLevel}-yearly`
  }

  // If currentPlan is a monthly plan, return {requiredPlanLevel}-monthly
  if (currentPlan.includes('monthly')) {
    return `${requiredPlanLevel}-monthly`
  }

  // If currentPlan is a yearly plan, return {requiredPlanLevel}-yearly
  if (currentPlan.includes('yearly')) {
    return `${requiredPlanLevel}-yearly`
  }

  // Default case: return pro-yearly
  return DEFAULT_PLAN
}
